import React from "react";
import CustomCard from "../../../shared/Card/CustomCard";
import EmployeeForm from "./EmployeeForm";

export default function AddEmployee({ name }) {
  return (
    <CustomCard title={name}>
      <EmployeeForm type="ADD" />
    </CustomCard>
  );
}
